









































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { Page } from '@/models/Page'
import HTMLEditor from '@/components/HTMLEditor.vue'
import Select from '@/components/Select.vue'

@Component({
	components: {
		HTMLEditor,
		Select,
	},
})
export default class PageForm extends Vue {
	@Prop({ default: null }) public editPage !: Page
	@Prop({ default: () => [] }) public parentValues !: object[]
	@Prop({ default: null }) public singleEdit!: string
	private page: Page = new Page()
	private formElements: object[] = [
		{ name: 'main', label: 'Display in GoSystems sidebar', type: 'checkbox'},
		{ name: 'name', label: 'URL Name (Don\'t Change)*', placeholder: 'Name', type: 'text', required: true },
		{ name: 'parent', label: 'Parent', placeholder: 'Parent', type: 'select', options: this.parentValues },
		{ name: 'label', label: 'Label*', placeholder: 'Label', type: 'text', required: true },
		{ name: 'title', label: 'Title', placeholder: 'Title of page in the browser and Google', type: 'text' },
		{ name: 'description', label: 'Description', placeholder: 'Text under the title in search results', type: 'text' },
		{ name: 'keywords', label: 'Keywords', placeholder: 'Keywords', type: 'textarea' },
		{ name: 'content', label: 'Content', placeholder: 'Content', type: 'html' },
	]

	@Watch('editPage')
	private onEditPageUpdate() {
		this.page = this.editPage
	}

	get filteredFormElements() {
		if (this.singleEdit) {
			return this.formElements.filter((element: any) => element.name === this.singleEdit)
		}
		return this.formElements
	}

	private created() {
		if (this.editPage) {
			this.page = this.editPage
		}
	}

	private beforeDestroy() {
		this.page.reset()
	}

	private submit() {
		this.$validator.validateAll().then((result) => {
			if (!result) {
				this.$toasted.error('Please fix form errors.')
				return
			}
			this.$emit('submit', this.page)
		})
	}
}
